<template>
    <!-- 予約情報を選択したときのポップアップメニュー -->
    <div style="min-width: 300px;">
        <div style="margin: 5px;">
            <div>処理メニュー{{ TargetBooking.bookingState==1 ? " | 仮予約" : TargetBooking.bookingState==2 ? " | 本予約" : TargetBooking.bookingState==4 ? " | 無効予約" : "" }}</div>
            <div style="display: grid; grid-template-columns: auto auto; gap: 0.5rem 2rem; margin-top: 5px;
                            background: white; padding: 5px 12px;">
                <div style="grid-column: 1/3">
                    <div style="font-size: 0.9rem">火葬炉 予約日時</div>
                    <div style="font-size: 1.2rem">{{getBookingDateTime(TargetBooking)}}</div>
                </div>
                <div>
                    <div style="font-size: 0.9rem">利用者名</div>
                    <div style="font-size: 1.3rem; line-height: 2rem;" v-if="TargetBooking.bookingState==3">仮押さえ</div>
                    <div style="font-size: 1.3rem; line-height: 2rem;" v-else class="j-mincho">{{TargetBooking.infoName1}} {{TargetBooking.infoName2}}</div>
                </div>
                <div>
                    <div style="font-size: 0.9rem">予約番号</div>
                    <div style="font-size: 1.3rem; line-height: 2rem;">{{TargetBooking.bookingCode}}</div>
                </div>
                <div style="grid-column: 1/3" v-if="TargetBooking.bookingState!=3">
                    <div style="font-size: 0.9rem">葬祭業者</div>
                    <div style="font-size: 1.3rem">{{TargetBooking.companyName}}</div>
                    <div style="font-size: 1.3rem">{{TargetBooking.telNumber}}<span style="font-size: 1rem; margin: 0 0.5rem">(電話番号)</span></div>
                </div>
            </div>
            <div class="booking-edit-dialog-buttons" style="margin-top: 1rem;">
                <template v-if="TargetBooking.bookingState==1">
                    <button @click="edit">予約を照会する/本予約へ進む</button>
                    <button @click="cancel">予約を無効にする</button>
                </template>
                <template v-if="TargetBooking.bookingState==2">
                    <button @click="edit">予約を照会する</button>
                    <button v-if="TargetBooking.approved==0" @click="approved(true)">承認する</button>
                    <button v-if="TargetBooking.approved==1" @click="approved(false)">承認を解除する</button>
                    <button @click="print">印刷ページを表示する</button>
                    <div style="height: 10px"></div>
                    <div style="display: grid; grid-template-columns: 1fr 80px; gap: 2px 1px">
                        <button @click="permit(true, false)">火葬場使用許可申請書</button>
                        <button @click="permit(true, true)">申請者空欄</button>

                        <button @click="permit(false, false)">火葬場使用許可証</button>
                        <button @click="permit(false, true)">申請者空欄</button>

                        <button @click="bone(true, false)">分骨証明交付申請書</button>
                        <button @click="bone(true, true)">申請者空欄</button>

                        <button @click="bone(false, false)">分骨証明書</button>
                        <button @click="bone(false, true)">申請者空欄</button>

                        <button @click="certificate(true, false)">火葬済証明交付申請書</button>
                        <button @click="certificate(true, true)">申請者空欄</button>

                        <button @click="certificate(false, false)">火葬済証明書</button>
                        <button @click="certificate(false, true)">申請者空欄</button>
                    </div>
                </template>
                <template v-if="TargetBooking.bookingState==3">
                    <button @click="edit">仮予約の入力に進む</button>
                    <button @click="remove">仮押さえ枠を開放する</button>
                </template>
                <template v-if="TargetBooking.bookingState==4">
                    <button @click="remove">予約情報を削除する</button>
                </template>
            </div>
        </div>
        <div class="dialog-bottom-buttons" style="margin-top: 16px">
            <button onclick="window.Dialog.close(false)">閉じる</button>
        </div>
    </div>
</template>

<script>
import Util from "../../assets/utility.js"
import { Dialog } from '../../assets/dialog.js'
import { Router } from '../../assets/router.js'
import { Auth } from "./../../assets/auth.js"
import { BookingController } from "../../assets/api/bookingController"

var Setting = window.Setting

export default {
    props: {
        TargetBooking: {
            default: {}
        },
    },
    data() {
        return {
            Api: {
                booking: new BookingController()
            },
        }
    },
    methods: {
        reload(){
            this.$emit("reload")
        },
        
        /** 予約編集 承認する */
        async approved(value){
            Dialog.spinAsync()
            let res = await this.Api.booking.setApproved(this.TargetBooking.bookingId, value)
            Dialog.close()
            if(!res.ok){
                this.error("更新できませんでした。")
                return
            }
            await this.reload()
        },

        /** 予約編集 予約情報を紹介する */
        async edit(){
            let id = this.TargetBooking.bookingId
            Router.navigateByKey("booking-edit", { id })
            Dialog.close()
        },

        /** 予約編集 無効にする */
        async cancel(){
            const tar = this.TargetBooking
            let msg = `${tar.infoName1} ${tar.infoName2}の予約を無効にします。\n無効にした予約は元に戻せません。`
            let ok = await Dialog.keywordboxAsync(msg, tar.bookingCode)
            if(!ok) return

            Dialog.spinAsync()
            let res = await this.Api.booking.cancel(tar.bookingId)
            Dialog.close()

            if(!res.ok){
                this.error("予約を更新できませんでした。"
                    + (res.status==400 ? `\n${res.body}` : ""))
                return
            }
            await this.info("予約を無効にしました。この枠に新たな予約を登録する場合は、予約情報の削除を行ってください。")
            await this.reload()
        },

        /** 予約編集 予約を削除する */
        async remove(){
            const tar = this.TargetBooking
            if(tar.bookingState == 3){
                let ok = await this.ask(`仮押さえを解除し予約可能な枠とします。`)
                if(!ok) return
            }else{
                let msg = `${tar.infoName1} ${tar.infoName2}の予約情報を削除し予約可能な枠とします。`
                let ok = await Dialog.keywordboxAsync(msg, tar.bookingCode)
                if(!ok) return
            }
            
            Dialog.spinAsync()
            let res = await this.Api.booking.delete(tar.bookingId, tar.bookingState)
            Dialog.close()

            if(!res.ok){
                this.error("削除できませんでした。"
                    + (res.status==400 ? `\n${res.body}` : ""))
                return
            }
            await this.reload()
        },

        /** 予約編集 印刷ページ */
        async print(){
            window.open(`/print/booking?id=${this.TargetBooking.bookingId}`, "_blank")
        },

        /** 印刷 火葬場使用許可書 */
        async permit(isApplication, isLeaveOwnerBlank){
            let id = this.TargetBooking.bookingId   
            let printDate = Util.getToday().getTime()
            this.download(`${Setting.api}report/report02`,
            {
                bookingId: id ,
                printDate : printDate / 1000,
                isApplication : isApplication,
                isLeaveOwnerBlank : isLeaveOwnerBlank
            },
            `${isApplication ? "火葬場使用許可申請書" : "火葬場使用許可証"}_${this.TargetBooking.bookingCode}.xlsx`)
        },

        /** 印刷 火葬済証明書 */
        async certificate(isApplication, isLeaveOwnerBlank){
            let id = this.TargetBooking.bookingId   
            let printDate = Util.getToday().getTime()
            this.download(`${Setting.api}report/report03`,
            {
                bookingId: id ,
                printDate : printDate / 1000,
                isApplication : isApplication,
                isLeaveOwnerBlank : isLeaveOwnerBlank
            },
            `${isApplication ? "火葬済証明交付申請書" : "火葬済証明書"}_${this.TargetBooking.bookingCode}.xlsx`)
        },
        
        /** 印刷 分骨済証明書 */
        async bone(isApplication, isLeaveOwnerBlank){
            let id = this.TargetBooking.bookingId
            let printDate = Util.getToday().getTime()
            this.download(`${Setting.api}report/report04`,
            {
                bookingId: id ,
                printDate : printDate / 1000,
                isApplication : isApplication,
                isLeaveOwnerBlank : isLeaveOwnerBlank
            },
            `${isApplication ? "分骨証明交付申請書" : "分骨証明書"}_${this.TargetBooking.bookingCode}.xlsx`)
        },

        //ダウンロード共通関数
        async download(urlx, body, name){
            Dialog.spinAsync()
            var res = await Auth.ajax({
                method: "POST",
                url: urlx,
                body: body,
                responseType: "blob",
            })

            if(!res.ok){
                let msg = "ファイルを作成できませんでした。"
                if(res.status==400) msg += `\n${res.body}`
                await this.error(msg)
                return
            }

            let url = window.URL.createObjectURL(res.body)

            let anchor = document.createElement("a")
            anchor.download = name
            anchor.href = url
            anchor.click()
            anchor.remove()
            setTimeout(() => window.URL.revokeObjectURL(url), 10000)
            
            Dialog.close()
        },

        async info(msg){
            return await Dialog.messageboxAsync(msg,
                Dialog.Messagebox_Buttons_Ok,
                Dialog.Messagebox_Icon_Info)
        },
        async ask(msg){
            return await Dialog.messageboxAsync(msg,
                Dialog.Messagebox_Buttons_OkCancel,
                Dialog.Messagebox_Icon_Info)
        },
        async error(msg){
            await Dialog.messageboxAsync(msg,
                Dialog.Messagebox_Buttons_Ok,
                Dialog.Messagebox_Icon_Error)
        },
        async warning(msg){
            await Dialog.messageboxAsync(msg,
                Dialog.Messagebox_Buttons_Ok,
                Dialog.Messagebox_Icon_Warn)
        },
        getBookingDateTime(rec){
            if(!rec || !("bookingDate" in rec)) return ""
            return Util.formatDate(rec.bookingDate, "yyyy年M月d日")
                + " " + Util.formatTime(rec.bookingTime)
        },
    },
}
</script>

<style scoped>
.booking-edit-dialog-buttons{
    display: flex;
    flex-direction: column;
    gap: 2px; 
}
.booking-edit-dialog-buttons button{
    padding: 3px 0;
}
</style>

